import React, { Suspense, useEffect, useCallback } from "react";
import classes from "./App.module.css";

import { Switch, Route } from "react-router-dom";

import Layout from "./components/Layout/Layout";
import Home from "./components/Home/Home";
import Spinner from "./components/UI/Spinner/Spinner";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "./store/actions/index";

const Resume = React.lazy(() => {
	return import("./components/Resume/Resume");
});
const Certification = React.lazy(() => {
	return import("./components/Certification/Certification");
});
const Contact = React.lazy(() => {
	return import("./components/Contact/Contact");
});
const Login = React.lazy(() => {
	return import("./components/Auth/Login/Login");
});
const Messages = React.lazy(() => {
	return import("./components/Auth/Messages/Messages");
});
const Logout = React.lazy(() => {
	return import("./components/Auth/Logout/Logout");
});
const HireMe = React.lazy(() => {
	return import("./components/HireMe/Hireme");
});

function App() {
	const dispatch = useDispatch();

	const tryAutoLogin = useCallback(() => dispatch(actions.tryAutoLogin()), [
		dispatch,
	]);

	const token = useSelector((state) => state.auth.token);

	useEffect(() => {
		tryAutoLogin();
	}, [tryAutoLogin]);

	let routes = (
		<Switch>
			<Route path='/' exact component={Home} />
			<Route path='/resume' render={() => <Resume />} />
			<Route path='/certificates' render={() => <Certification />} />
			<Route path='/contact' render={() => <Contact />} />
			<Route path='/login' render={(props) => <Login {...props} />} />
			<Route path='/hire-me' render={() => <HireMe />} />
			<Route component={Home} />
			{/* <Redirect to='/' /> */}
		</Switch>
	);
	if (token)
		routes = (
			<Switch>
				<Route path='/' exact component={Home} />
				<Route path='/resume' render={() => <Resume />} />
				<Route path='/certificates' render={() => <Certification />} />
				<Route path='/contact' render={() => <Contact />} />
				<Route path='/messages' render={() => <Messages />} />
				<Route path='/logout' render={() => <Logout />} />
				<Route path='/hire-me' render={() => <HireMe />} />
				<Route component={Home} />
			</Switch>
		);
	return (
		<div className={classes.App}>
			<Layout>
				<Suspense fallback={<Spinner />}>{routes}</Suspense>
			</Layout>
		</div>
	);
}

export default App;
